import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.$bg_gray};
  width: 100vw;
  height: 100vh;
  overflow-x: hidden !important;

  &.hasTopBanner {
    padding-top: 80px;

    @media only screen and (max-width: 768px) {
      padding-top: 240px;
    }
  }

  &.hasAmbassadorBanner {
    padding-top: 52px;

    @media only screen and (max-width: 768px) {
      padding-top: 72px;
    }
  }
`;
